export const admin = {
  admin: {
    addWhitelistRuleModal: {
      adding: 'Adding...',
      addRule: 'Add Rule',
      addWhitelistRule: 'Add Whitelist Rule',
      cancel: 'Cancel',
      modelProviders: 'Model Providers',
      selectAWorkspace: 'Select a workspace',
      selectTheProviderThisModel: 'Select the provider this model will be available',
      selectTheWorkspaceWhichThe: 'Select the workspace which the model will be available',
      workspace: 'Workspace',
    },
    addWorkspaceConfig: {
      addWorkspaceConfiguration: 'Add Workspace Configuration',
      cancel: 'Cancel',
      removeWorkspace: 'Remove {{name}}',
      saveForWorkspaces_one: 'Save for {{count}} workspace',
      saveForWorkspaces_other: 'Save for {{count}} workspaces',
      selectOneOrMoreWorkspaces:
        'Select one or more workspaces and configure the tool settings for them.',
      selectWorkspaces: 'Select workspaces',
    },
    adFormats: {
      title: 'Ad Formats',
      globalNotice:
        'These formats and specs apply to every organisation. Switching organisation does not change what you edit here.',
      import: 'Import',
      export: 'Export',
      newFormat: 'New format',
      newGroup: 'New group',
      emptyGroup: 'No formats yet.',
      addFormatToGroup: 'Add a format to {{group}}',
      searchLabel: 'Search formats',
      searchPlaceholder: 'Search by name or size',
      noMatches: 'No formats match your search.',
      loadFailed: 'The format library could not be loaded.',
      retry: 'Try again',
      selectFormat: 'Select a format to see and edit its specs.',
      deprecated: 'Deprecated',
      tabs: {
        general: 'General',
        image: 'Image',
        video: 'Video',
        textLimits: 'Text limits',
        history: 'History',
      },
      fields: {
        key: 'Key',
        keyHint: 'Becomes the format id. It can never be changed.',
        group: 'Platform group',
        name: 'Name',
        surface: 'Surface',
        surfaceHint: 'Where inside the group the ad runs, such as Instagram.',
        aliases: 'Aliases',
        aliasesHint: 'Separate with commas. Search matches them.',
        width: 'Width (px)',
        height: 'Height (px)',
        status: 'Status',
        notes: 'Notes',
      },
      status: {
        active: 'Active',
        deprecated: 'Deprecated',
      },
      save: 'Save',
      saving: 'Saving...',
      cancel: 'Cancel',
      saved: 'Saved as version {{version}}.',
      nothingChanged: 'Nothing changed, so no new version was created.',
      errors: {
        versionConflict:
          'Someone else saved this format since you opened it. Reload it and apply your change again.',
        validationFailed: 'The change would leave the library invalid:',
        alreadyExists: 'That key is already in use.',
        generic: 'The change could not be saved.',
      },
      messages: {
        key_format: 'Use lowercase letters, digits and single hyphens.',
        name_required: 'A name is required.',
        status_invalid: 'Status must be active or deprecated.',
        unknown_group: 'Unknown platform group "{{group}}".',
        unknown_spec_profile: 'Unknown spec profile "{{profile}}".',
        unknown_format: 'Unknown format "{{key}}".',
        unknown_profile: 'Unknown profile "{{key}}".',
        owner_type_invalid: 'Owner type must be format or profile.',
        width_invalid: 'Width must be a positive whole number of pixels.',
        height_invalid: 'Height must be a positive whole number of pixels.',
        pixels_invalid: 'Not a positive whole number of pixels.',
        whole_number: 'Not a whole number.',
        property_twice: 'This property is set twice.',
        unknown_property: '"{{mediaType}}.{{property}}" is not a known spec property.',
        provenance_invalid: 'The value or its requirement or scope is not valid.',
        limited_twice: 'This field is limited twice.',
        unknown_text_field: 'Unknown field "{{field}}", or check requirement and scope.',
        value_empty: 'An empty value is not allowed. Write N/A when the platform does not say.',
        format_group_locked: 'A format cannot move to another platform group.',
        size_format: 'Write a size as WxH, with ? for a side the platform does not give.',
        number_format: 'Write a plain number in the base unit, with no unit.',
        kb_format: 'Write the file size as a number of KB, with no unit.',
        range_format: 'Write a range as min..max.',
        number_list_format: 'Write numbers separated by commas.',
        boolean_format: 'Write true or false.',
        margins_format: 'Write the safe zone as top, right, bottom, left in pixels.',
        file_skipped:
          '{{file}}: the header matches none of the library files, so the file was skipped.',
        unknown_columns: '{{file}}: ignored unknown columns {{columns}}.',
      },
      breaking: {
        title: 'Confirm a change that can break existing work',
        description:
          'A new canvas size unlinks frames already built at the old size, and deprecating a format removes it from every picker. Adding a new format instead keeps existing work intact.',
        confirm: 'Save anyway',
      },
      spec: {
        property: 'Property',
        value: 'Value',
        requirement: 'Requirement',
        notChecked: 'Not checked',
        notApplicable: 'N/A',
        inherited: 'From {{profile}}',
        edit: 'Edit {{property}}',
        sheetDescription: 'Set whether this value is required and where it applies.',
        notApplicableLabel: 'The platform does not specify this (N/A)',
        sizeHint: 'Leave a side empty when the platform does not give it.',
        marginsHint:
          "Pixels in from each edge of this format's canvas. Leave a side empty for no inset.",
        marginsValue: 'Top {{top}}, right {{right}}, bottom {{bottom}}, left {{left}} px',
        chooseTransparency: 'Choose how transparency is handled',
        fileSizeKb: 'Maximum size (KB)',
        kilobytes: '{{value}} KB',
        commaListHint: 'Separate entries with commas, e.g. {{example}}.',
        newEntry: 'Add a codec',
        addEntry: 'Add',
        removeEntry: 'Remove {{entry}}',
        margins: {
          top: 'Top (px)',
          right: 'Right (px)',
          bottom: 'Bottom (px)',
          left: 'Left (px)',
        },
        transparency: {
          supported: 'Supported',
          not_supported: 'Not supported',
          flattened: 'Flattened onto a background',
          required: 'Required',
        },
        valueHint:
          'Write it as {{example}}. Numbers use the base unit: bytes, seconds, kbps, Hz or fps.',
        scope: 'Scope',
        clear: 'Clear (not checked)',
        errors: {
          size_format: 'Write a size as WxH, with ? for a side the platform does not give.',
          number_format: 'Write a plain number in the base unit, with no unit.',
          range_format: 'Write a range as min..max.',
          number_list_format: 'Write numbers separated by commas.',
          boolean_format: 'Write true or false.',
          margins_format: 'Write the safe zone as top, right, bottom, left in pixels.',
          valueRequired: 'Enter a value, or mark it N/A.',
          marginSide: 'Use a whole number of pixels, or leave the side empty.',
          kbFormat: 'Write the size as a number of KB.',
          listRequired: 'Add at least one codec, or mark it N/A.',
          sizeSide: 'Use a whole number of pixels, or leave the side empty.',
          sizeRequired: 'Enter a width, a height or both, or mark it N/A.',
        },
      },
      diagram: {
        canvas: "This format's canvas, {{width}} × {{height}} px",
        value: 'The value being edited',
        safeArea: 'Safe area',
        captions: {
          size: "The asset's size, drawn against this format's canvas. A dashed edge is a side the platform does not give.",
          ratio: "The asset's shape, drawn inside this format's canvas.",
          ratioList: "Every shape the platform accepts, drawn inside this format's canvas.",
          safeZone:
            'Keep text, logos and buttons inside the safe area; the platform may cover the rest.',
          file: 'Applies to the uploaded file itself: its type, encoding or weight.',
          color: 'Applies to how colour and transparency are encoded in the file.',
          duration: 'Applies to how long the video runs.',
          frameRate: 'Applies to how many frames the video shows each second.',
          bitrate: 'Applies to how much data each second of video carries.',
          audio: "Applies to the video's audio track.",
          cropping: 'Applies to how the platform may crop the asset when it shows it.',
          thumbnail: 'Applies to the cover image shown before the video plays.',
        },
      },
      requirement: {
        required: 'Required',
        recommended: 'Recommended',
        accepted: 'Accepted',
      },
      scope: {
        placement: 'Placement',
        general_upload: 'General upload',
        api: 'API',
      },
      textLimit: {
        field: 'Field',
        maxChars: 'Max characters',
        recommendedChars: 'Recommended',
        truncatesAt: 'Truncates at',
        allowedValues: 'Allowed values',
        allowedValuesHint: 'Separate with commas, where the platform fixes the choices.',
        fields: {
          headline: 'Headline',
          primaryText: 'Primary text',
          description: 'Description',
          callToAction: 'Call to action',
          displayUrl: 'Display URL',
          brandName: 'Brand name',
          adName: 'Ad name',
        },
        errors: {
          number: 'Use a whole number, or leave it empty.',
        },
      },
      history: {
        empty: 'No changes recorded for this format yet.',
        version: 'Version {{version}}',
        restore: 'Restore to here',
        restored: 'Restored as version {{version}}.',
        operation: {
          create: 'Created',
          update: 'Updated',
          delete: 'Removed',
        },
      },
      newFormatDialog: {
        description: 'The key becomes the format id and can never change, so choose it carefully.',
        create: 'Create format',
        keyInvalid: 'Use lowercase letters, digits and single hyphens.',
        required: 'Required.',
        sizeInvalid: 'Use a positive whole number of pixels.',
      },
      newGroupDialog: {
        description:
          'A platform group collects the formats of one platform, such as Reddit. Its key can never change, so choose it carefully.',
        keyHint: 'Becomes the group id. It can never be changed.',
        create: 'Create group',
      },
      importDialog: {
        title: 'Import CSV',
        description:
          'Upload one or more CSV files exported from this page. Nothing changes until you confirm.',
        chooseFiles: 'CSV files',
        preview: 'Preview',
        confirm: 'Confirm import',
        changes_one: '{{count}} record will change.',
        changes_other: '{{count}} records will change.',
        noChanges: 'These files change nothing.',
        fileCounts:
          '{{file}}: {{new}} new, {{updated}} updated, {{unchanged}} unchanged, {{conflict}} conflicting, {{ignored}} skipped',
        ignoredTitle_one: '{{count}} row could not be used',
        ignoredTitle_other: '{{count}} rows could not be used',
        ignoredRow: '{{file}}, row {{row}}: {{reason}}',
        ignoredTruncated:
          'Only the first {{shown}} are shown here. Download the skipped rows for the full list.',
        downloadIgnored: 'Download skipped rows',
        conflictsTitle: 'Changed since the files were exported',
        keepFile: 'Use the file',
        keepCurrent: 'Keep the current value',
        breakingTitle: 'These formats get a new size or are deprecated:',
        confirmBreaking: 'I understand this can break work already built on them',
        warnings: 'Warnings',
        imported: 'Imported as version {{version}}.',
        stale:
          'The library changed while you were reviewing. The preview has been refreshed; check it and confirm again.',
      },
    },
    adminLayout: {
      adFormats: 'Ad Formats',
      aiModels: 'AI Models',
      customization: 'Customization',
      etlConfig: 'ETL Config',
      mcpCatalog: 'MCP Catalog',
      tools: 'Tools',
    },
    organizationSettings: {
      content: 'Content',
      adminSettings: 'Admin settings',
      back: 'Back',
      opensInNewTab: '{{label}} (opens in a new tab)',
      collapseRail: 'Collapse menu',
      expandRail: 'Expand menu',
      platform: 'Platform',
      settingsSections: 'Settings sections',
      switchOrganization: 'Switch organization',
      toolsAndAgents: 'Tools & Agents',
    },
    agentConfigPage: {
      advanced: 'Advanced',
      agentNotFound: 'Agent not found',
      allWorkspacesWillUseThe: 'All workspaces will use the organization-level configuration.',
      backToTools: 'Back to Tools',
      configurationForThisToolAcross: 'Configuration for this tool across all workspaces.',
      configured: 'Configured',
      configureIndividualToolsForSpecific:
        'Configure individual tools for specific sub-agents. Changes here override the organization-level configuration for the selected sub-agent.',
      organization: 'Organization',
      partiallyConfigured: 'Partially configured',
      partiallyConfiguredCount: '{{workspaceCount}} partially configured',
      subAgentConfiguredFor:
        '<bold>{{fieldKey}}</bold>: Configured for {{configured}} of {{total}} sub-agents',
      subAgentUsedBy: '<bold>{{fieldKey}}</bold>: Used by {{total}} sub-agents',
      subAgentUsedByPartial: '(configured for {{configured}} of {{total}})',
      thisToolHasNoConfigurable: 'This tool has no configurable settings.',
      workspace: 'Workspace',
      workspaceSpecificOverridesForThis: 'Workspace-specific overrides for this tool.',
    },
    agentNodeCard: {
      configured: 'Configured',
      needsSetup_one: '{{count}} needs setup',
      needsSetup_other: '{{count}} need setup',
      subagent: 'subagent',
      subagentCount_one: '{{count}} subagent',
      subagentCount_other: '{{count}} subagents',
      toolCount_one: '{{count}} tool',
      toolCount_other: '{{count}} tools',
      unconfigured: '{{unconfiguredCount}} unconfigured',
    },
    agentCategoryOptions: {
      create: 'Create',
      deliver: 'Deliver',
      plan: 'Plan',
      scale: 'Scale',
    },
    agentToolBasicInformation: {
      basicInformation: 'Basic Information',
      cancel: 'Cancel',
      category: 'Category',
      edit: 'Edit',
      save: 'Save',
      toolDescription: 'Tool Description',
      toolName: 'Tool Name',
    },
    categoriesPanel: {
      addCategory: 'Add Category',
      addOrganizationCategory: 'Add Organization Category',
      addWorkspaceCategory: 'Add Workspace Category',
      cancel: 'Cancel',
      categoriesHelpOrganizeExternalTools:
        'Categories help organize external tools into logical groups. Add your first category to get started.',
      categoryName: 'Category Name',
      editOrganizationCategory: 'Edit Organization Category',
      editWorkspaceCategory: 'Edit Workspace Category',
      enterCategoryName: 'Enter Category Name',
      noCategoriesYet: 'No categories yet',
      organization: 'Organization',
      thisActionCannotBeUndone: 'This action cannot be undone.',
      thisWillAlsoPermanentlyDelete_one:
        'This will also permanently delete {{count}} tool in this category. This action cannot be undone.',
      thisWillAlsoPermanentlyDelete_other:
        'This will also permanently delete {{count}} tools in this category. This action cannot be undone.',
      thisWillPermanentlyDelete_one:
        'This will permanently delete {{count}} tool in this category. Since this is an organization wide category, any workspace-specific tools using it will also be removed. This action cannot be undone.',
      thisWillPermanentlyDelete_other:
        'This will permanently delete {{count}} tools in this category. Since this is an organization wide category, any workspace-specific tools using it will also be removed. This action cannot be undone.',
      title: 'Title',
      update: 'Update',
      visible: 'Visible',
      visibleToUsers: 'Visible to users',
    },
    clearOpportunitiesConfirmationModal: {
      allOpportunitiesInWorkspace: 'All opportunities in workspace "{{workspaceName}}"',
      cancel: 'Cancel',
      clearOpportunities: 'Clear Opportunities',
      deleteOpportunities: 'Delete {{opportunitiesCount}} Opportunities',
      deleting: 'Deleting...',
      opportunitiesInFromTo:
        'Opportunities in "{{workspaceName}}" from {{dateStart}} to {{dateEnd}}',
      thisActionCannotBeUndone:
        'This action cannot be undone. All selected opportunities and their associated favorites will be permanently deleted from this workspace.',
      youAreAboutToPermanentlyDelete:
        'You are about to permanently delete <strong>{{opportunitiesCount}} opportunities</strong>.',
    },
    clearWorkspaceOpportunitiesAction: {
      clearAllOpportunities: 'Clear all opportunities',
      clearByDateRange: 'Clear by date range',
      clearOpportunities: 'Clear Opportunities',
      dateRange: 'Date Range',
      deletionMode: 'Deletion Mode',
      endDate: 'End Date',
      endDate2: 'End date',
      noOpportunitiesFoundMatchingYour: 'No opportunities found matching your criteria.',
      opportunitiesWillBeDeleted_one: '{{count}} opportunity will be deleted',
      opportunitiesWillBeDeleted_other: '{{count}} opportunities will be deleted',
      permanentlyDeleteOpportunitiesFromThis:
        'Permanently delete opportunities from this workspace. This action cannot be undone.',
      preview: 'Preview',
      selectADateRangeTo: 'Select a date range to preview',
      startDate: 'Start Date',
      startDate2: 'Start date',
    },
    customization: {
      customization: 'Customization',
      customizationSaved: 'Customization saved',
      customizeTheLabelsAndDescriptions:
        'Customize the labels and descriptions shown on the Springboard categories.',
      description: 'Description',
      descriptionMaxLength: 'Description must be at most {{max}} characters',
      emptyFieldsUseDefault:
        "Leave a field empty to show its default copy, translated into each reader's language.",
      failedToLoadCustomizationSettings:
        'Failed to load customization settings. Please refresh the page and try again.',
      label: 'Label',
      labelMaxLength: 'Label must be at most {{max}} characters',
      saveChanges: 'Save changes',
      saving: 'Saving...',
      subtitle: 'Subtitle',
      subtitleMaxLength: 'Subtitle must be at most {{max}} characters',
    },
    etlConfig: {
      add: 'Add',
      addContentSource: 'Add Content Source',
      addDomainsByTypingAnd: 'Add domains by typing and pressing Enter',
      cancel: 'Cancel',
      contentSourceResource: 'Content Source',
      created: 'Created: {{date}}',
      delete: 'Delete',
      domains: 'Domains',
      edit: 'Edit',
      editContentSource: 'Edit Content Source',
      eGSubredditNameChannel: 'e.g., subreddit name, channel name, Twitter handle',
      etlConfig: 'ETL Config',
      noContentSourcesFoundAdd:
        'No content sources found. Add your first content source to get started.',
      noContentSourcesMatchYour: 'No content sources match your search query.',
      platform: 'Platform',
      reddit: 'Reddit',
      searchByTopic: 'Search by topic',
      searchContentSourcesLabel: 'Search content sources',
      sourceCount_one: '{{count}} source',
      sourceCount_other: '{{count}} sources',
      thisActionCannotBeUndone: 'This action cannot be undone.',
      topic: 'Topic',
      typeAndPressEnterTo: 'Type and press Enter to add domains',
      update: 'Update',
      xTwitter: 'X (Twitter)',
      youTube: 'YouTube',
    },
    externalToolsOverview: {
      categories: 'Categories',
      externalTools: 'External Tools',
      getTheInfoYouNeed: 'Get the info you need to get work done',
      ofSectionsConfigured: '{{configuredCount}} of 2 sections configured',
      setupChecklist: 'Setup checklist',
    },
    externalToolsPage: {
      addAndManageExternalToolsForTheOrganization:
        'Add and manage external tools for the Organization',
      addAndManageExternalToolsForThisWorkspace: 'Add and manage external tools for this workspace',
      addCategory: 'Add Category',
      addExternalTool: 'Add External Tool',
      cancel: 'Cancel',
      categories: 'Categories',
      configurationOverviewAndStatistics: 'Configuration overview and statistics',
      confirm: 'Confirm',
      externalTools: 'External Tools',
      manageExternalToolCategoriesForTheOrganization:
        'Manage external tool categories for the Organization',
      manageExternalToolCategoriesForThisWorkspace:
        'Manage external tool categories for this workspace',
      overview: 'Overview',
      updateToolForEntireOrganization: 'Update tool for entire organization?',
      youReEditingThisTool:
        "You're editing this tool at the organization level. This will become the new default for all workspaces that haven't set their own override.",
    },
    externalToolsPanel: {
      addExternalTool: 'Add External Tool',
      addExternalToolsThatUsers:
        'Add external tools that users can access from the SCJ Resources tool.',
      addOrganizationExternalTool: 'Add Organization External Tool',
      addWorkspaceExternalTool: 'Add Workspace External Tool',
      cancel: 'Cancel',
      categories: 'Categories',
      category: 'Category',
      description: 'Description',
      editOrganizationExternalTool: 'Edit Organization External Tool',
      editWorkspaceExternalTool: 'Edit Workspace External Tool',
      enterExternalToolDescription: 'Enter External Tool Description',
      enterExternalToolTitle: 'Enter External Tool Title',
      externalTool: 'external tool',
      externalToolUrl: 'External Tool URL',
      failedToUploadImage: 'Failed to upload image',
      image: 'Image',
      noCategoriesAvailable: 'No categories available',
      noExternalToolsYet: 'No external tools yet',
      organization: 'Organization',
      preview: 'preview',
      remove: 'Remove',
      replace: 'Replace',
      theExternalLinkThatOpens: 'The external link that opens when users click this tool',
      title: 'Title',
      unknown: 'Unknown',
      update: 'Update',
      upload: 'Upload',
      visibility: 'Visibility',
      visibleToUsers: 'Visible to users',
      youNeedToCreateAt: 'You need to create at least one category before adding external tools.',
    },
    htmlTemplateManager: {
      addTemplate: 'Add template',
      cancelRename: 'Cancel rename',
      code: 'Code',
      confirmRename: 'Confirm rename',
      deleteTemplate: 'Delete {{templateKey}}',
      previewTemplate: 'Preview: {{templateKey}}',
      newTemplateName: 'New template name',
      noContentToPreview: 'No content to preview',
      noTemplatesConfiguredYet: 'No templates configured yet',
      pasteYourHtmlTemplateHere: 'Paste your HTML template here...',
      preview: 'Preview',
      renameTemplate: 'Rename {{templateKey}}',
      viewMode: 'Editor view mode',
    },
    htmlTemplateWidget: {
      edit: 'Edit',
      htmlPreview: 'HTML Preview',
      htmlTemplate: 'HTML Template',
      preview: 'Preview',
    },
    manageToolWorkspacesModal: {
      allExceptSelectedWorkspaces: 'All except selected workspaces ({{selectedCount}})',
      allWorkspaces: 'All workspaces',
      cancel: 'Cancel',
      couldnTSaveTheWorkspace: "Couldn't save the workspace access. Try again.",
      manageToolWorkspaces: 'Manage tool workspaces',
      managingWorkspacesForTool: 'Managing workspaces for {{toolName}} tool',
      selectWhichWorkspacesThe:
        'Select which workspaces the {{toolName}} tool will be available in.',
      onlyInSelectedWorkspaces: 'Only in selected workspaces ({{selectedCount}})',
      noWorkspaces: 'No workspaces',
      removeWorkspace: 'Remove {{workspaceName}}',
      saveChanges: 'Save changes',
      selectWorkspaces: 'Select workspaces',
      thisToolWillBeAvailable: 'This tool will be available only in the selected workspaces',
      thisToolWillBeAvailable2:
        'This tool will be available in all workspaces except the selected ones',
      thisToolWillNotBe: 'This tool will not be available in any workspace in this organization',
      workspaces: 'Workspaces',
    },
    mcpCatalogPage: {
      addAndManageMcpServers:
        'Add and manage MCP servers that members can install and connect with their own credentials.',
      mcpCatalog: 'MCP Catalog',
      moreActions: 'More actions',
    },
    mcpCatalogPanel: {
      addMcpServer: 'Add MCP server',
      addMcpServersThatMembers: 'Add MCP servers that members of this org/workspace can install.',
      auth: 'Auth',
      authType: 'Auth type',
      cancel: 'Cancel',
      changingCredentialsSignsOut:
        'Changing these will sign out everyone currently connected to this server. They will need to connect again.',
      clientId: 'Client ID',
      clientRegistration: 'Client registration',
      clientRegistrationConfigured: 'Configured',
      clientSecret: 'Client secret',
      clientSecretStored: 'A secret is stored. Enter a new one to replace it.',
      description: 'Description',
      editMcpServer: 'Edit MCP server',
      eGAtlassian: 'e.g. Atlassian',
      mostServersRegisterAutomatically:
        'Most servers let us register automatically, so you can leave this empty. Fill it in when the provider requires you to register an application yourself, such as in a developer console.',
      name: 'Name',
      noAuth: 'No auth',
      noMcpServersInThe: 'No MCP servers in the catalog yet',
      oauth: 'OAuth',
      removeCredentials: 'Remove credentials',
      staticHeaders: 'Static headers',
      update: 'Update',
      url: 'URL',
      whatThisMcpServerProvides: 'What this MCP server provides',
    },
    opportunityScheduleConfig: {
      changesWillTakeEffectFrom: 'Changes will take effect from tomorrow.',
      configureWhenAutomatedOpportunityDiscovery:
        'Configure when automated opportunity discovery runs for this organization.',
      failedToUpdateSchedule: 'Failed to update schedule',
      nothingToScheduleYet: 'Nothing to schedule yet',
      noWorkspaceIsReadyTo:
        'No workspace is ready to receive opportunities yet. Complete a workspace configuration on the Workspace tab before scheduling runs.',
      opportunityRunSchedule: 'Opportunity Run Schedule',
      pleaseTryAgain: 'Please try again.',
      scheduleUpdatedSuccessfully: 'Schedule updated successfully',
    },
    overviewCard: {
      notConfigured: 'Not configured',
    },
    providerWhitelistCard: {
      aiModelProviders: 'AI Model Providers',
      cancel: 'Cancel',
      configureWhichAiModelProviders:
        'Configure which AI model providers are available for your organization',
      edit: 'Edit',
      noProvidersSelected: 'No providers selected',
      save: 'Save',
    },
    removeProviderConfirmationModal: {
      areYouSureYouD: "Are you sure you'd like to confirm?",
      cancel: 'Cancel',
      modelsAreWhitelisted_one:
        'The model {{names}} is whitelisted in a rule. Removing this model will automatically delete the rule.',
      modelsAreWhitelisted_other:
        'The models {{names}} are whitelisted in rules. Removing these models will automatically delete the rules.',
      removeProviders: 'Remove Providers',
      removing: 'Removing...',
      yesRemove: 'Yes, remove',
    },
    rowMenu: {
      delete: 'Delete',
      edit: 'Edit',
      rowActions: 'Row actions',
    },
    scheduleEditor: {
      automatedDiscoveryIsCurrentlyDisabled: 'Automated discovery is currently disabled',
      clearAll: 'Clear All',
      daily: '(Daily)',
      dayPerWeek_one: '({{count}} day/week)',
      dayPerWeek_other: '({{count}} days/week)',
      disabled: 'Disabled',
      enableAutomatedOpportunityDiscovery: 'Enable automated opportunity discovery',
      enabled: 'Enabled',
      friday: 'Friday',
      monday: 'Monday',
      noDaysSelected: '(No days selected)',
      noDaysSelectedOpportunitiesWill:
        'No days selected - opportunities will not run until you select at least one day.',
      runningDailyEveryDayOf: 'Running daily (every day of the week)',
      runningTimesPerWeek_one: 'Running {{count}} time per week',
      runningTimesPerWeek_other: 'Running {{count}} times per week',
      saturday: 'Saturday',
      saveSchedule: 'Save Schedule',
      saving: 'Saving...',
      selectAll: 'Select All',
      selectWhichDaysOpportunitiesShould:
        'Select which days opportunities should run. All times are at 12:00 AM ET (05:00 UTC).',
      status: 'Status',
      sunday: 'Sunday',
      thursday: 'Thursday',
      tuesday: 'Tuesday',
      wednesday: 'Wednesday',
      weeklySchedule: 'Weekly Schedule',
      whenEnabledTheSystemWill:
        'When enabled, the system will automatically discover and analyze opportunities based on the configured schedule below.',
    },
    scopeTab: {
      createConfiguration: 'Create Configuration',
      delete: 'Delete',
      deleteConfigurationTitle: 'Delete configuration',
      noConfigurationSetForThis: 'No configuration set for this scope',
      save: 'Save',
      saving: 'Saving...',
      thisWillRemoveTheConfiguration:
        'This will remove the configuration for this scope. This action cannot be undone.',
    },
    toolBreadcrumb: {
      backToTools: 'Back to Tools',
    },
    toolConfigForm: {
      emailTemplates: 'Email Templates',
      selectAtLeastItem_one: 'Select at least {{count}} item.',
      selectAtLeastItem_other: 'Select at least {{count}} items.',
      selectAtMostItem_one: 'Select at most {{count}} item.',
      selectAtMostItem_other: 'Select at most {{count}} items.',
      thisFieldIsRequired: 'This field is required.',
    },
    toolConfigPage: {
      agentNotFound: 'Agent not found',
      allWorkspacesWillUseThe: 'All workspaces will use the organization-level configuration.',
      backToTools: 'Back to Tools',
      configurationForTheAgentAcross:
        'Configuration for the {{agentName}} agent across all workspaces.',
      countConfigured: '{{configuredCount}} configured',
      organization: 'Organization',
      workspaceSpecificOverridesForThe: 'Workspace-specific overrides for the {{agentName}} agent.',
      workspace: 'Workspace',
      configured: 'Configured',
    },
    toolRow: {
      configure: 'Configure',
      edit: 'Edit',
    },
    tools: {
      all: 'All',
      archived: 'Archived',
      couldnTLoadTheTools: "Couldn't load the tools.",
      createCustomTool: 'Create Custom Tool',
      custom: 'Custom',
      filterToolsByType: 'Filter tools by type',
      noToolsMatchThisFilter: 'No tools match this filter',
      noToolsYet: 'No tools yet',
      retry: 'Retry',
      searchToolsLabel: 'Search tools',
      system: 'System',
      theToolWillBeDeactivated: 'The tool will be deactivated and hidden from all users.',
      toolsList: 'Tools list',
      tryADifferentTypeFilter: 'Try a different type filter, or clear it to see everything.',
    },
    toolsTable: {
      configurationStatus: 'Configuration Status',
      configured: 'Configured',
      configureTool: 'Configure tool',
      custom: 'Custom',
      deleteTool: 'Delete tool',
      description: 'Description',
      editTool: 'Edit tool',
      manageWorkspaces: 'Manage workspaces',
      moreActions: 'More actions',
      name: 'Name',
      system: 'System',
      thisToolDoesnTHave: "This tool doesn't have configurable properties",
      toolActions: 'Tool actions',
      toolsUnconfigured_one: '{{count}} tool unconfigured',
      toolsUnconfigured_other: '{{count}} tools unconfigured',
      type: 'Type',
      workspaces: 'Workspaces',
    },
    useAgentConfig: {
      configurationRemoved: 'Configuration removed',
      configurationSaved: 'Configuration saved',
      failedToRemoveConfiguration: 'Failed to remove configuration',
      failedToSaveConfiguration: 'Failed to save configuration',
    },
    useClearWorkspaceOpportunities: {
      failedToClearOpportunities: 'Failed to clear opportunities',
      successfullyClearedAllOpportunities:
        'Successfully cleared all {{deletedCount}} opportunities in {{workspaceName}}',
      successfullyClearedOpportunitiesInDateRange:
        'Successfully cleared {{deletedCount}} opportunities in {{workspaceName}} (date range)',
    },
    useCreateCatalogMcp: {
      failedToAddMcpServerTo: 'Failed to add MCP server to the catalog',
      mcpServerAddedToThe: 'MCP server added to the catalog',
    },
    useDeleteCatalogMcp: {
      failedToRemoveMcpServerFrom: 'Failed to remove MCP server from the catalog',
      mcpServerRemovedFromThe: 'MCP server removed from the catalog',
    },
    useEtlContentSources: {
      contentSourceAddedSuccessfully: 'Content source added successfully!',
      contentSourceDeletedSuccessfully: 'Content source deleted successfully!',
      contentSourceUpdatedSuccessfully: 'Content source updated successfully!',
      failedToAddContentSource: 'Failed to add content source',
      failedToDeleteContentSource: 'Failed to delete content source',
      failedToUpdateContentSource: 'Failed to update content source',
    },
    useSaveAgentOverride: {
      couldNotSaveToolDisplay: 'Could not save tool display name or description',
    },
    useSaveProviderWhitelist: {
      failedToUpdateModelProvider: 'Failed to update model provider whitelist',
      modelProviderWhitelistUpdated: 'Model provider whitelist updated!',
    },
    useToolConfigScopes: {
      configurationRemoved: 'Configuration removed',
      configurationSaved: 'Configuration saved',
      configurationSavedToWorkspaces: 'Configuration saved to workspaces',
      failedToRemoveConfiguration: 'Failed to remove configuration',
      failedToSaveConfiguration: 'Failed to save configuration',
      failedToSaveConfigurationTo: 'Failed to save configuration to workspaces',
    },
    useUpdateCatalogMcp: {
      failedToUpdateMcpServer: 'Failed to update MCP server',
      mcpServerUpdated: 'MCP server updated',
    },
    workspaceAccessChips: {
      all: 'All',
      allExcept: 'All except:',
      none: 'None',
      noWorkspaces: 'No workspaces',
      onlyIn: 'Only in:',
    },
    workspaceChips: {
      otherWorkspaces: 'Other {{remainingCount}} workspaces',
    },
    workspaceConfigRow: {
      configuration: 'Configuration',
      customSchedule: 'Custom schedule',
      delete: 'Delete',
      needsKnowledgeBase: 'Needs a knowledge base',
      save: 'Save',
      saveTheConfigurationToCreate:
        'Save the configuration to create the run schedule for this workspace.',
      scheduleNotCreatedYet: 'No run schedule yet',
      scheduleUnavailableNoKnowledgeBase: 'Scheduling disabled: no knowledge base',
      selectAKnowledgeBaseAbove:
        'Opportunities cannot run without one. Select a knowledge base above, then save.',
      selectAKnowledgeBaseBefore: 'Select a knowledge base before saving.',
      thisWillRemoveTheWorkspace:
        'This will remove the workspace-specific configuration. The organization-level configuration will apply instead.',
    },
    workspaceProviderWhitelistRules: {
      deleteWhitelistRuleFor: 'Delete whitelist rule for "{{workspaceName}}"?',
      failedToAddWorkspaceWhitelist: 'Failed to add workspace whitelist rule',
      failedToDeleteWorkspaceWhitelist: 'Failed to delete workspace whitelist rule',
      thisWillRemoveAllModel: 'This will remove all model provider rules for this workspace.',
      workspaceWhitelistRuleAdded: 'Workspace whitelist rule added!',
      workspaceWhitelistRuleDeleted: 'Workspace whitelist rule deleted!',
    },
    workspaceScheduleSection: {
      changesWillTakeEffectFrom: 'Changes will take effect from tomorrow.',
      clearGenerationEndDate: 'Clear',
      failedToRemoveOverride: 'Failed to remove override',
      failedToUpdateWorkspaceSchedule: 'Failed to update workspace schedule',
      generationEndDateDescription:
        'Opportunity generation stops after this day. Leave empty for no cutoff.',
      generationEndDateInterpretedAsUtc: 'The date is interpreted as UTC.',
      generationEndDateLabel: 'Last day of generation',
      generationEndDatePlaceholder: 'Pick a cutoff date',
      generationEndedOn: 'Generation ended on {{date}}',
      inheritingOrganization: '(inheriting organization)',
      override: '(override)',
      overrideRemoved: 'Override removed',
      pleaseTryAgain: 'Please try again.',
      resetAlsoClearsCutoff: 'Resetting also clears the generation end date.',
      resetToOrganization: 'Reset to organization',
      resetting: 'Resetting...',
      runSchedule: 'Run Schedule',
      thisWorkspaceNowFollowsThe: 'This workspace now follows the organization schedule.',
      workspaceOverrideCreated: 'Workspace override created',
      workspaceScheduleUpdated: 'Workspace schedule updated',
    },
    workspaceScopeTab: {
      addWorkspaceConfiguration: 'Add Workspace Configuration',
      addWorkspaces: 'Add Workspaces',
      // The noun agrees with the workspace total but the verb with the configured count, and a
      // key carries only one `count`, so the verb axis rides on `context`.
      customConfigurationSummary_plural_one:
        '{{configured}} of {{count}} workspace have custom configuration.',
      customConfigurationSummary_plural_other:
        '{{configured}} of {{count}} workspaces have custom configuration.',
      customConfigurationSummary_singular_one:
        '{{configured}} of {{count}} workspace has custom configuration.',
      customConfigurationSummary_singular_other:
        '{{configured}} of {{count}} workspaces has custom configuration.',
      noWorkspaceSpecificConfigurations: 'No workspace-specific configurations',
      partiallyConfiguredWarning:
        'Some workspaces are only partially configured — not all tools have values set. You can open a workspace and press <save>Save</save> to apply the current values to all tools, or use the <advanced>Advanced</advanced> tab to configure each tool individually.',
    },
    workspaceScopeTabs: {
      current: 'Current',
      organization: 'Organization',
    },
    workspaceWhitelistRulesHeader: {
      addRule: 'Add Rule',
      restrictSpecificWorkspacesToUse:
        'Restrict specific workspaces to use only selected model providers',
      searchWorkspaceRules: 'Search workspace rules...',
      searchWorkspaceRulesLabel: 'Search workspace rules',
      workspaceRules: 'Workspace Rules ({{rulesCount}})',
    },
    workspaceWhitelistRulesTable: {
      clickOnAddRuleTo: 'Click on "Add rule" to add one',
      deleteRuleFor: 'Delete rule for {{workspaceName}}',
      noRulesMatchYourSearch: 'No rules match your search',
      noWhitelistRuleAddedYet: 'No whitelist rule added yet',
      tryAdjustingYourSearchTerm: 'Try adjusting your search term',
      whitelistedProviders: 'Whitelisted Providers',
      workspace: 'Workspace',
    },
  },
  agent: {
    agentDetail: {
      agentNotFound: 'Agent not found',
    },
    agentModal: {
      noDescriptionDefined: 'No description defined',
    },
  },
  agents: {
    inputSchema: {
      errorAgentSchemaIsInvalid:
        'Error: Agent schema is invalid, please check the schema and try again.',
    },
  },
  connectedApps: {
    connectedAppsPage: {
      connectedApps: 'Connected apps',
    },
    connectedAppsTable: {
      access: 'Access',
      actions: 'Actions',
      actionsFor: 'Actions for {{clientName}}',
      connected: 'Connected',
      disconnect: 'Disconnect',
      emptyDescription:
        'Anything you authorize in {{organizationName}} will appear here. Applications connected in your other organizations are listed separately, under those organizations.',
      emptyTitle: 'No connected applications',
      errorDescription: 'Something went wrong on our side. Refresh the page to try again.',
      errorTitle: 'Could not load your connected applications',
      name: 'Name',
      noMatchesDescription: 'Try a different name.',
      noMatchesTitle: 'No matching applications',
      searchLabel: 'Search connected apps',
    },
    disconnectAppDialog: {
      body: 'It will no longer be able to act on your behalf in {{organizationName}}. To give it access again you will have to authorize it from scratch.',
      cancel: 'Cancel',
      confirm: 'Disconnect',
      title: 'Disconnect {{clientName}}?',
    },
    useDisconnectApp: {
      couldNotDisconnect: 'Could not disconnect {{clientName}}. Please try again.',
      wasDisconnected: '{{clientName}} was disconnected.',
    },
  },
  externalTool: {
    useCreateExternalTool: {
      externalToolCreatedSuccessfully: 'External tool created successfully!',
      failedToCreateExternalTool: 'Failed to create external tool',
    },
    useCreateExternalToolCategory: {
      categoryCreated: 'Category created!',
      failedToCreateCategory: 'Failed to create category',
    },
    useDeleteExternalTool: {
      externalToolDeleted: 'External tool deleted!',
      failedToDeleteExternalTool: 'Failed to delete external tool',
    },
    useDeleteExternalToolCategory: {
      categoryDeleted: 'Category deleted!',
      failedToDeleteCategory: 'Failed to delete category',
    },
    useDeleteExternalToolCategoryWithCascade: {
      categoryAndAssociatedToolsDeleted: 'Category and associated tools deleted!',
      failedToDeleteCategoryAnd: 'Failed to delete category and associated tools',
    },
    useUpdateExternalTool: {
      externalToolUpdatedSuccessfully: 'External tool updated successfully!',
      failedToUpdateExternalTool: 'Failed to update external tool',
    },
    useUpdateExternalToolCategory: {
      categoryUpdated: 'Category updated!',
      failedToUpdateCategory: 'Failed to update category',
    },
  },
  externalToolsWidget: {
    externalTools: 'External Tools',
    externalToolsEmptyState: {
      externalToolsWillAppearHere: 'External tools will appear here once they are added',
      externalToolsWillAppearHereInCategory:
        'External tools will appear here once they are added to this category',
      noExternalToolsAvailable: 'No external tools available',
      noToolsIn: 'No tools in {{categoryName}}',
    },
    externalToolsFilter: {
      all: 'All',
    },
  },
  myMcps: {
    myMcpsPage: {
      installMcpServersFromYour:
        "Install MCP servers from your organization's catalog and manage their credentials.",
      myMcps: 'My MCPs',
    },
  },
  templatesConfig: {
    customInstructions: {
      button: 'Custom instructions',
      buttonSet: 'Custom instructions · Set',
      cancel: 'Cancel',
      counter: '{{count}}/{{max}}',
      description:
        'Standing instructions the AI applies every time it writes an email from this template.',
      help: 'Use this for rules that apply to every email from this template — tone, wording, things to always include or never say. Anything here is treated like part of your own prompt, so it takes precedence over the knowledge base.',
      label: 'Instructions (optional)',
      placeholder:
        'e.g. Always write in British English. Never use exclamation marks. The footer must always mention our returns policy.',
      save: 'Save',
      title: 'Custom instructions',
    },
    configureElement: {
      addAttribute: 'Add attribute',
      attributeName: 'Attribute name',
      attributeNameRequired: 'Add a name, or clear the value to drop this row.',
      attributeNamePlaceholder: 'e.g. data-client-id',
      attributeValue: 'Attribute value',
      attributeValuePlaceholder: 'Value (optional)',
      cancel: 'Cancel',
      contentHtml: 'Content (HTML)',
      customAttributes: 'Custom attributes',
      duplicateAttributeName: 'This attribute is already set on the element.',
      elementSelector: 'Element',
      failedToApplyChanges: 'Failed to apply the changes.',
      imageDescription: 'Image description (optional)',
      imageDescriptionHelp:
        'Used to help pick a matching image from the knowledge base when the agent updates this template.',
      imageDescriptionPlaceholder: 'Describe the ideal image for this slot...',
      cannotDeleteLockedElement:
        'This element, or content inside it, is locked and cannot be deleted.',
      cannotLocateElement:
        'This element cannot be located safely in the template source, so it cannot be deleted.',
      clearSectionName: 'Clear section name',
      deleteElement: 'Delete element',
      deleteElementTitle: 'Delete this <{{tagName}}>?',
      deleteElementWarning: 'This action cannot be undone.',
      deleteElementWarningWithSections_one:
        'This also removes 1 editable section: {{sections}}. This action cannot be undone.',
      deleteElementWarningWithSections_other:
        'This also removes {{count}} editable sections: {{sections}}. This action cannot be undone.',
      elementDeleted: 'Element deleted.',
      failedToDeleteElement: 'Failed to delete the element.',
      invalidAttributeName: 'Not a valid HTML attribute name.',
      removeAttribute: 'Remove attribute',
      reservedAttributeName: 'This attribute is reserved and cannot be set here.',
      save: 'Save',
      sectionName: 'Section Name',
      sectionNameHelp:
        'Name it to let the AI update this element. Leave blank to only edit it here.',
      sectionNamePlaceholder: 'e.g. hero-headline',
      sectionNameReserved: '"{{slug}}" is reserved for internal use — pick another name.',
      sectionNameTaken: '"{{slug}}" is already used by another section in this template.',
      textContent: 'Text content',
      title: 'Configure Content Element',
    },
    errorState: {
      couldntLoadEmailTemplates: "Couldn't load email templates",
      retry: 'Retry',
      somethingWentWrongPleaseTry: 'Something went wrong. Please try again.',
    },
    editableContents: {
      editSection: 'Edit section {{sectionName}}',
      emptyState:
        'Start adding contents by clicking on the components on the email in preview mode',
      noUpdatableSections:
        'This template has no updatable sections. Without them, the AI cannot generate content for it. Start adding contents by clicking on the components on the email in preview mode.',
      clearMarker: 'Clear marker on "{{sectionName}}"',
      clearMarkerHelp: 'Clears the AI marker. The element stays in the template.',
      sectionRemoved: 'Marker cleared on "{{sectionName}}". The element stays.',
      title: 'Editable contents',
    },
    editor: {
      backToTemplates: 'Back to email templates',
      code: 'Code',
      desktopPreview: 'Desktop preview',
      emailTemplates: 'Email templates',
      mobilePreview: 'Mobile preview',
      pasteHtmlPlaceholder: '<paste html here>',
      preview: 'Preview',
      renameTemplate: 'Rename template',
      save: 'Save',
      sectionNotFound: 'Section "{{sectionName}}" is no longer in the template.',
      templateNotFound: 'That email template no longer exists.',
    },
    mutations: {
      customInstructionsSaved: 'Custom instructions saved',
      failedToCreateTemplate: 'Failed to create the template.',
      failedToDeleteTemplate: 'Failed to delete the template.',
      failedToRenameTemplate: 'Failed to rename the template.',
      failedToSaveCustomInstructions: 'Failed to save the custom instructions.',
      failedToSaveTemplate: 'Failed to save the template.',
      templateNoLongerExists: 'That template no longer exists, so your changes were not saved.',
      templateAlreadyExists: 'Template "{{name}}" already exists.',
      templateSaved: 'Template saved',
    },
    nameModal: {
      add: 'Add',
      cancel: 'Cancel',
      needsLatinCharacters:
        "Add at least one Latin letter or digit — the name is used to build the template's address.",
      nameAlreadyUsed: 'A template with this name already exists.',
      newEmailTemplate: 'New Email Template',
      rename: 'Rename',
      renameEmailTemplate: 'Rename Email Template',
      templateName: 'Template Name',
    },
  },
  userMcpServers: {
    chatMcpServers: {
      builtIn: 'Built-in',
      checking: 'Checking…',
      connected: 'Connected',
      connectors: 'Connectors',
      reconnect: 'Reconnect',
      retry: 'Retry',
      unavailable: 'Unavailable',
    },
    mcpHeadersModal: {
      addHeader: 'Add header',
      addTheAuthHeadersThis:
        'Add the auth headers this server needs (e.g. <auth>Authorization</auth> \u2192 <bearer>Bearer \u2026</bearer>). Leave empty if it requires no authentication. Stored encrypted.',
      authorization: 'Authorization',
      bearer: 'Bearer …',
      cancel: 'Cancel',
      header: 'Header',
      headersAreAlreadySetBut:
        'Headers are already set but hidden. Entering new ones replaces all stored headers.',
      editHeadersFor: 'Edit headers — {{mcpName}}',
      install: 'Install',
      installMcp: 'Install {{mcpName}}',
      removeHeader: 'Remove header',
      saveHeaders: 'Save headers',
      value: 'Value',
    },
    mcpHealthBadge: {
      accessDenied: 'Access denied',
      serverSaid: 'The server said: "{{detail}}"',
      accessDeniedHint:
        'The server accepted the sign-in and refused the request anyway. Reconnecting will not help; someone who administers that server needs to grant access to this application.',
      authFailed: 'Auth failed',
      error: 'Error',
      notAnMcpServer: 'Not an MCP server',
      reCheckConnection: 'Re-check connection',
      refreshConnectionStatus: 'Refresh connection status',
      timedOut: 'Timed out',
      unreachable: 'Unreachable',
    },
    mcpMarketplace: {
      available: 'Available',
      builtIn: 'Built-in',
      connect: 'Connect',
      disconnect: 'Disconnect',
      editHeaders: 'Edit headers',
      install: 'Install',
      installed: 'Installed',
      noAuthRequired: 'No auth required',
      noMcpServersAvailable: 'No MCP servers available',
      oauth: 'OAuth',
      requiresHeaders: 'Requires headers',
      uninstall: 'Uninstall',
      yourOrganizationHasnTAdded:
        "Your organization hasn't added any MCP servers to the catalog yet. Once an admin adds one, you'll be able to install it here.",
      youVeInstalledEverythingIn: "You've installed everything in the catalog.",
    },
    useConnectMcp: {
      couldNotConnectTheMcp: 'Could not connect the MCP server',
      couldNotStartTheOauth: 'Could not start the OAuth connection',
      mcpServerConnected: 'MCP server connected',
    },
    useInstallMcp: {
      failedToInstallMcpServer: 'Failed to install MCP server',
      mcpServerInstalled: 'MCP server installed',
    },
    useUninstallMcp: {
      failedToUninstallMcpServer: 'Failed to uninstall MCP server',
      mcpServerUninstalled: 'MCP server uninstalled',
    },
    useUpdateMcpCredentials: {
      credentialsUpdated: 'Credentials updated',
      failedToUpdateCredentials: 'Failed to update credentials',
    },
  },
} as const;
